import Converter from './Converter';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  gameListUrl: 'smartsoft/get_game_list',
  converter,
  sessionUrlData: {
    url: 'smartsoft/get_game_launcher',
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getQuery: params =>
      `?game_category=${params.game?.gameCategory || ''}&game_name=${params.game?.gameName || ''}&return_url=${
        params.url
      }&lang=${params.lang}`,
    getHeaders: () => ({
      headers: {
        'x-partner-name': projectName,
        'x-partner-authorization': parseCookies(),
      },
    }),
  },
};
